import { useReducedMotion } from 'motion/react';
import type { Variants } from 'motion/react';

/**
 * Single gate for "should this animate?".
 *
 * Every motion primitive routes through here, so turning on the OS-level
 * "reduce motion" setting makes the whole app render instantly instead of
 * animating — required for the dashboards people use all day.
 */
export const useMotionSafe = () => {
  const prefersReduced = useReducedMotion();
  const enabled = !prefersReduced;

  /** Returns the variants, or a no-op pair when motion is disabled. */
  const safeVariants = (variants: Variants): Variants =>
    enabled ? variants : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  /** Returns the given props, or nothing when motion is disabled. */
  const safeProps = <T extends object>(props: T): T | Record<string, never> =>
    enabled ? props : {};

  return { enabled, prefersReduced: !!prefersReduced, safeVariants, safeProps };
};

export default useMotionSafe;
